import { ACTION_TYPE, fetchJson, ResponseError } from '../../store/actionCreatorsHelpers';

export function fetchUser() {
    return {
        type: ACTION_TYPE.REQUEST_USER,
        payload: fetchJson('api/user/current').catch((err: ResponseError) => {
            if (err.statusCode === 404) {
                return null;
            }
            throw err;
        }),
    };
}
export function toggleAdminMode() {
    return {
        type: ACTION_TYPE.TOGGLE_ADMIN_MODE,
    };
}
